document.addEventListener('DOMContentLoaded', function() {
    console.log('@@@@@@@@@@@@@@@@');
  const wrapper = document.querySelector('product-recommendations[data-related-products-loadmore]');
  if (!wrapper || wrapper.dataset.relatedProductsLoadmore === 'false') return;

  const initialVisible = parseInt(wrapper.dataset.initialVisible || '8', 10);
  const increment = 4;
  let visibleCount = initialVisible;
  let grid = null;
  let isMouseOverGrid = false;
  let gridMouseOverHandler = null;
  let gridMouseLeaveHandler = null;
  let scrollHandler = null;

  function refreshElements() {
    grid = document.getElementById('related-products-grid');
  }

  function getItems() {
    return grid ? Array.from(grid.querySelectorAll('.grid__item')) : [];
  }

  function hideExtraItems(items) {
    items.forEach((item, index) => {
      item.style.display = index < visibleCount ? '' : 'none';
    });
  }

  function shouldShowMore() {
    if (!grid) return false;
    const rect = grid.getBoundingClientRect();
    return rect.bottom <= window.innerHeight + 100;
  }

  function handleGridMouseOver(event) {
    if (!event.target.closest('.grid__item')) return;
    isMouseOverGrid = true;
    if (shouldShowMore()) showMore();
  }

  function handleGridMouseLeave() {
    isMouseOverGrid = false;
  }

  function handleWindowScroll() {
    if (!isMouseOverGrid) return;
    if (shouldShowMore()) showMore();
  }

  function detachGridEvents() {
    if (!grid) return;
    if (gridMouseOverHandler) grid.removeEventListener('mouseover', gridMouseOverHandler);
    if (gridMouseLeaveHandler) grid.removeEventListener('mouseleave', gridMouseLeaveHandler);
    if (scrollHandler) window.removeEventListener('scroll', scrollHandler);
    gridMouseOverHandler = null;
    gridMouseLeaveHandler = null;
    scrollHandler = null;
    isMouseOverGrid = false;
  }

  function showMore() {
    console.log('Show more related products');
    const items = getItems();
    const nextCount = Math.min(visibleCount + increment, items.length);

    for (let i = visibleCount; i < nextCount; i++) {
      items[i].style.display = '';
    }

    visibleCount = nextCount;

    if (visibleCount >= items.length) {
      detachGridEvents();
    }
  }

  function initializeObserver() {
    console.log('Initializing related products load more observer');
    refreshElements();
    const items = getItems();
    if (!grid || !items.length) return;

    visibleCount = Math.min(initialVisible, items.length);
    hideExtraItems(items);

    detachGridEvents();

    if (items.length > visibleCount) {
      gridMouseOverHandler = handleGridMouseOver;
      gridMouseLeaveHandler = handleGridMouseLeave;
      scrollHandler = handleWindowScroll;

      grid.addEventListener('mouseover', gridMouseOverHandler);
      grid.addEventListener('mouseleave', gridMouseLeaveHandler);
      window.addEventListener('scroll', scrollHandler, { passive: true });

      console.log('Attached grid mouseover + scroll handlers for load more');
    } else {
      console.log('No hidden items, not setting up mouseover/scroll handlers');
    }
  }

  const mutationObserver = new MutationObserver(() => {
    initializeObserver();
  });

  mutationObserver.observe(wrapper, { childList: true, subtree: true });
  initializeObserver();
});